import { StoreState } from '../store-interfaces';

export const selectLeadsSearchFilterAttributes = (state: StoreState) =>
  state.leads.attributes;

export const selectPurchasableLeads = (state: StoreState) =>
  state.leads.contacts.hits;

export const selectPurchasableLeadsCount = (state: StoreState) =>
  state.leads.contacts.total;

export const selectFreezedCreditsSum = (state: StoreState) =>
  state.leads.freezedCretitsSum;
